export default (initialVotes = 0) => ({

    votes: initialVotes,

    handleUpvote(){

        const self = this;
            
        let formData = new FormData(self.$refs.upvote);
        
        self.submitting = true;

        axios.post('', formData)
            .then(function (response) {                            
                self.onUpvoteSuccess(response.data);
            }).catch(function (error) {
                console.log(error);
            });

    },

    handleDownvote() {

        const self = this;
        
        let formData = new FormData(self.$refs.downvote);
        
        self.submitting = true;

        axios.post('', formData)
            .then(function (response) {
                self.onDownvoteSuccess(response.data);
            }).catch(function (error) {
                console.log(error);
            });

    },

    onUpvoteSuccess(response){

        if(response.success){
            this.votes++;
        }
    },

    onDownvoteSuccess(response){

        if(response.success){
            this.votes--;
        }
    },

    voteCount(){

        if(this.votes > 0){
            return '+' + this.votes;
        }
        
        if(this.votes < 0) {
            return this.votes;
        }

        return 0;
    }

});